import { FC } from "react";
import { Alert, Typography } from "@mui/material";

export const DimensionStatusAlert: FC = () => {
  return (
    <Alert severity="info" variant="outlined" sx={{ bgcolor: "white" }}>
      <Typography variant="body2">
        After creating or updating a category, may take some time to show up in
        the Billing Explorer.
      </Typography>
    </Alert>
  );
};
